<template>
<ClientOnly>
    <div v-if="pack" class="plat-icons-container">
        <div v-for="(platform, idx) in externalStorefronts" :key="idx">
            <NuxtLink
                :href="storefrontLink(pack.slug, platform.vendor)"
                target="_blank"
                :aria-label="`link to ${platform.vendor} storefront`"
                tabindex="0"
                class="external-storefront"
                :class="[platform.vendor, getProductClass(pack.slug)]"
                external
                v-on:click="$launchDarkly.trackStorefrontClick(pack.slug, platform.vendor, product)"
            >
                <PlatformIcon
                    :platform="platform.icon"
                    :alt="platform.text || ''"
                    :classes="['storefront-icon']"
                />
            </NuxtLink>
        </div>
    </div>
</ClientOnly>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { Shopify } from '@jackboxgames/shopify'
import PlatformIcon from 'public/images/icons/platforms/PlatformIcon.vue'
import { getStorefrontLink, getProductGTMClass } from '$services/storefronts/storefronts'
import type { JBGWeb } from '$types/JBGWeb'

export default defineNuxtComponent({
    components: { PlatformIcon },
    props: {
        pack: Object as PropType<JBGWeb.PackDetail>,
        product: Object as PropType<Shopify.Product>,
        platformOptions: Object,
        fellBackToEn: {
            type: Boolean,
            required: false,
            default: false
        },
        isBundle: {
            type: Boolean,
            required: false,
            default: false
        },
        isLocalized: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        externalStorefronts(): JBGWeb.PlatformOption[] {
            return this.platformOptions.filter((p) => p.vendor !== 'shopify')
        }
    },

    methods: {
        getProductClass(packSlug: string) {
            return getProductGTMClass(packSlug)
        },

        storefrontLink(slug: string, platform: string): URL | string | undefined {
            if (!platform || !slug) return undefined
            if (!this.pack) return undefined
            const { locale } = useI18n()
            return getStorefrontLink(locale.value, slug, platform, this.fellBackToEn, this.isBundle, this.isLocalized)
        }
    }
})
</script>

<style scoped lang="scss">
@use "$styles/kit.scss" as *;

.plat-icons-container {
    display: flex;
    justify-content: space-around;
    padding: 12px 0;

    :deep(.storefront-icon) {
        margin: 0 6px;
        height: 28px;
        width: 28px;
        color: var(--neutral-50);

        @include mq-small {
            margin: 0px 2px;
            height: 20px;
            width: 20px;
        }

        @include mq-xsmall {
            height: 20px;
            width: 20px;
        }
    }
}
</style>
